var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-avatar',{attrs:{"color":_vm.ratingUI.bg,"size":"43"}},[_c('div',{class:("font-weight-bold text-body-2 " + (_vm.ratingUI.text))},[_vm._v(" "+_vm._s(_vm.rate || '0.00')+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }